/**
 * Preprocesa fotos de tickets para mejorar lectura con Tesseract en móvil.
 * Escala, escala de grises y contraste simple.
 */
export async function preprocessImageForOcr(file) {
  if (!file || !file.type?.startsWith('image/')) return file;

  const bitmap = await createImageBitmap(file);
  const targetWidth = 1800;
  const scale = Math.max(1, Math.min(2.5, targetWidth / Math.max(bitmap.width, 1)));
  const w = Math.round(bitmap.width * scale);
  const h = Math.round(bitmap.height * scale);

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return file;

  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();

  const imageData = ctx.getImageData(0, 0, w, h);
  const { data } = imageData;

  for (let i = 0; i < data.length; i += 4) {
    const gray = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    const contrast = Math.min(255, Math.max(0, (gray - 128) * 1.35 + 128));
    const v = contrast > 155 ? 255 : contrast < 95 ? 0 : contrast;
    data[i] = v;
    data[i + 1] = v;
    data[i + 2] = v;
  }

  ctx.putImageData(imageData, 0, 0);

  const blob = await new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b || file), 'image/jpeg', 0.9);
  });

  return new File([blob], file.name.replace(/\.\w+$/, '') + '-ocr.jpg', { type: 'image/jpeg' });
}
